export let StatusSeverityKey;
(function (StatusSeverityKey) {
  StatusSeverityKey["DEFAULT"] = "DEFAULT";
  StatusSeverityKey["WARNING"] = "WARNING";
  StatusSeverityKey["SUCCESS"] = "SUCCESS";
  StatusSeverityKey["DANGER"] = "DANGER";
  StatusSeverityKey["INFO"] = "INFO";
})(StatusSeverityKey || (StatusSeverityKey = {}));
export const STATUS_SEVERITY = {
  [StatusSeverityKey.DANGER]: 'danger',
  [StatusSeverityKey.DEFAULT]: 'default',
  [StatusSeverityKey.INFO]: 'info',
  [StatusSeverityKey.SUCCESS]: 'success',
  [StatusSeverityKey.WARNING]: 'warning'
};
export const SEVERITY_RANK = {
  [StatusSeverityKey.SUCCESS]: 1,
  [StatusSeverityKey.DEFAULT]: 2,
  [StatusSeverityKey.INFO]: 3,
  [StatusSeverityKey.WARNING]: 4,
  [StatusSeverityKey.DANGER]: 5
};